var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      staticClass:
        "modal_original_content_add_photo modal fade upload-card-detail",
      attrs: {
        "aria-hidden": "true",
        "data-backdrop": "static",
        "data-keyboard": "false",
        role: "dialog",
        tabindex: "-1"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog update-card-design" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c(
              "div",
              { staticClass: "body-black bold text-center title block" },
              [
                _c("div", [_vm._v("\n            Add Photo\n          ")]),
                _vm._v(" "),
                _c("button", {
                  class: [
                    "close",
                    {
                      "btn-disabled": !["INITIATED", "COMPLETE"].includes(
                        _vm.image.status
                      )
                    }
                  ],
                  attrs: {
                    "aria-label": "Close",
                    "data-dismiss": "modal",
                    type: "button"
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                })
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body clear-fix" }, [
            _c("div", { staticClass: "form-group i-field" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.label,
                    expression: "label"
                  }
                ],
                staticClass: "form-control large_body inputs",
                staticStyle: { maxlength: "1000" },
                attrs: { type: "text", placeholder: "Enter Label" },
                domProps: { value: _vm.label },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.label = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.image.status !== "COMPLETE" && !_vm._init_image_url,
                    expression:
                      "image.status !== 'COMPLETE' && !_init_image_url"
                  }
                ],
                class: [
                  "upload-dropzone",
                  {
                    "in-progress": !["INITIATED", "COMPLETE"].includes(
                      _vm.image.status
                    ),
                    dragover: _vm.dragover
                  }
                ],
                on: {
                  click: _vm.onClick,
                  drop: function($event) {
                    $event.preventDefault()
                    return _vm.onDrop.apply(null, arguments)
                  },
                  dragover: function($event) {
                    $event.preventDefault()
                    _vm.dragover = true
                  },
                  dragleave: function($event) {
                    $event.preventDefault()
                    _vm.dragover = false
                  }
                }
              },
              [
                _c("input", {
                  ref: "fileInput",
                  attrs: { type: "file", accept: ".jpeg, .jpg, .png" },
                  on: {
                    change: function($event) {
                      return _vm.selectionProcessing($event)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.image.status === "INITIATED"
                  ? _c("div", [_vm._m(0)])
                  : _vm.image.status === "CHECKING"
                  ? _c("div", [_vm._v("Checking...")])
                  : _vm.image.status === "UPLOADING"
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.image.upload_percentage) + "%")
                    ])
                  : ["COMPLETE"].includes(_vm.image.status)
                  ? _c("div", [_vm._v("Complete")])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.image.status === "COMPLETE" || _vm._init_image_url,
                    expression: "image.status === 'COMPLETE' || _init_image_url"
                  }
                ],
                staticClass: "text-center"
              },
              [
                _vm._init_image_url
                  ? _c("img", {
                      staticClass: "img-responsive",
                      attrs: { src: _vm._init_image_url, alt: "" }
                    })
                  : _c("img", {
                      staticClass: "img-responsive",
                      attrs: { src: _vm.image.url, alt: "" }
                    }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "new-line",
                    staticStyle: {
                      "margin-top": "20px",
                      display: "flex",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "round-btn-small",
                        staticStyle: { width: "200px" },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            return _vm.changeImage()
                          }
                        }
                      },
                      [_vm._v("\n              Change Image\n            ")]
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: [
                  "btn-primary-v2",
                  "add-photo-original-text-card",
                  "mt-3",
                  { "btn-disabled": !_vm.isCanBeProcessed }
                ],
                staticStyle: { cursor: "pointer" },
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.done()
                  }
                }
              },
              [_vm._v("\n          Add\n        ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "upload-image-title" }, [
      _c("div", { staticClass: "bold-text" }, [
        _vm._v("Drag your image here or click to add one!")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "reg-text" }, [
        _vm._v("The max file size: 10 MB")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }